import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { marketingUrl } from "../lib/marketingUrls";

/** Sends unmatched (and root) app URLs to the equivalent marketing-site path. */
export default function MarketingRedirect() {
  const location = useLocation();

  useEffect(() => {
    window.location.replace(
      marketingUrl(`${location.pathname}${location.search}${location.hash}`)
    );
  }, [location.hash, location.pathname, location.search]);

  return null;
}
